/* istanbul ignore file */
// TODO: Create test file

import requestUtil from '../../utils/requestUtil';
import { TOGGLE, FETCH } from '../../types/actions';
import {
  SET_FETCHED_PRODUCT,
  SET_FETCHING_STATUS,
  SET_SLIDEOUT_TITLE,
  SET_ACTIVE_PRODUCT_ID,
  SET_ACTIVE_SWATCH_COLOR,
  SET_FIRST_MOUNT,
  SET_NAVIGATION_SLIDEOUT,
  SET_PREFERRED_COMPS,
  SET_ACTIVE_EXISTING_DATA,
} from '../../types/setters';

const { convertNoColorToWhite, handleNoColorIdSelected, handleDefaultColorUnavailable } = require('../../modules/third-variant/mappers/3rdVariant');

/**
 *
 * @param {*} state
 * @param {*} productId
 * @returns
 */
function isCached(state, productId) {
  return Object.keys(state.fetchedProducts).includes(productId);
}

export const state = () => ({
  fetchedProducts: {},
  activeFetchedProduct: null,
  activeAnalyticsData: null,
  activeProductId: null,
  activeSwatchColor: null,
  isFetching: false,
  isFirstMount: false,
  navigationSlideout: null,
  preferredComps: [],
});

export const mutations = {
  /**
   *
   * @param {*} qvState
   * @param {*} incomingData
   */
  [SET_FETCHED_PRODUCT](qvState, { productId, fetchedProduct }) {
    // caching that productId state whether there's data or not
    qvState.fetchedProducts[productId] = fetchedProduct;

    // handling failed / no data
    if (!fetchedProduct) {
      qvState.activeFetchedProduct = null;
      qvState.activeAnalyticsData = null;

    // store/load available data
    } else {
      qvState.activeFetchedProduct = fetchedProduct?.product[0];
      qvState.activeAnalyticsData = fetchedProduct?.meta?.analytics?.data;
    }
  },

  [SET_ACTIVE_EXISTING_DATA](qvState, { productId, isAlreadyCached }) {
    if (isAlreadyCached && productId) {
      qvState.activeFetchedProduct = qvState.fetchedProducts[productId]?.product[0];
      qvState.activeAnalyticsData = qvState.fetchedProducts[productId]?.meta?.analytics?.data;
    }
  },

  [SET_ACTIVE_PRODUCT_ID](qvState, productId) {
    qvState.activeProductId = productId;
  },

  // External source like (Stylitics) may not have the color ID but instead just the color name
  [SET_ACTIVE_SWATCH_COLOR](qvState, swatchColor) {
    qvState.activeSwatchColor = swatchColor;
  },

  [SET_FETCHING_STATUS](qvState, isFetching) {
    qvState.isFetching = isFetching;
  },

  [SET_SLIDEOUT_TITLE](qvState, slideoutTitle) {
    qvState.slideoutTitle = slideoutTitle;
  },

  [SET_FIRST_MOUNT](qvState, shouldMount) {
    qvState.isFirstMount = shouldMount;
  },

  [SET_NAVIGATION_SLIDEOUT](qvState, payload) {
    qvState.navigationSlideout = payload;
  },

  [SET_PREFERRED_COMPS](qvState, payload) {
    qvState.preferredComps = payload;
  },
};

export const actions = {
  [TOGGLE]({ state: qvState, commit, dispatch }, { productId, slideoutTitle = '', swatchColor }) {
    if (!productId) return;
    commit(SET_FETCHING_STATUS, true);
    commit(SET_SLIDEOUT_TITLE, slideoutTitle);
    dispatch(FETCH, { productId, swatchColor });

    if (!qvState.isFirstMount) {
      commit(SET_FIRST_MOUNT, true);
      // must wait for the component to dynamically mount on the page first
      setTimeout(() => commit('slideoutStore/TOGGLE', 'product-quickview', { root: true }), 300);
    } else {
      commit('slideoutStore/TOGGLE', 'product-quickview', { root: true });
    }
  },

  async [FETCH]({ state: qvState, commit }, { productId, swatchColor = null }) {
    function alsoDoTheseThings() {
      commit(SET_FETCHING_STATUS, false);
      commit(SET_ACTIVE_PRODUCT_ID, productId);
      commit(SET_ACTIVE_SWATCH_COLOR, swatchColor);
    }

    // eslint-disable-next-line consistent-return
    function fetchProductParser(product) {
      const TOP_LEVEL_MATTRESS_CATEGORY_ID = '25931';
      const isMcomMattress = product?.identifier?.topLevelCategoryID === TOP_LEVEL_MATTRESS_CATEGORY_ID;

      if (!product) return null;

      if (!Object.keys(product.traits).length) {
        // setting default value. Other option is to make change in upcMap check in MCL
        product.traits = {
          traitsMaps: {
            upcMap: {},
          },
        };
      } else if (product.detail.flags.isConsolidatedThirdVariant && isMcomMattress) {
        convertNoColorToWhite(product);
        handleNoColorIdSelected(product);
      }

      if (product.detail.flags.isConsolidatedThirdVariant) {
        handleDefaultColorUnavailable(product);
      }
    }

    // response
    function handleResponse({ fetchedProduct = null }) {
      fetchProductParser(fetchedProduct?.product[0]);
      commit(SET_FETCHED_PRODUCT, { productId, fetchedProduct });
      alsoDoTheseThings();
    }

    // validate cached
    const _isCached = isCached(qvState, productId);

    if (_isCached) {
      // adding small delay to allow content refresh not to flickr
      setTimeout(() => {
        commit(SET_ACTIVE_EXISTING_DATA, { productId, isAlreadyCached: true });
        alsoDoTheseThings();
      }, 300);
      return;
    }

    // trigger
    try {
      const { getXapiProduct } = requestUtil();
      const res = await getXapiProduct(productId);
      handleResponse({ fetchedProduct: res });
    } catch (e) {
      handleResponse({ fetchedProduct: null });
      console.warn(`XAPI CAll Failed within Product Quickview [ID: ${productId}]`); // eslint-disable-line no-console
    }
  },
};
